import React from 'react';

import ReactSelect,{StylesConfig} from 'react-select';

const SelectStyles : StylesConfig<any> = ({
    control:(styles,{isDisabled,isFocused})=>{
      return {
        ...styles,
        backgroundColor:'white',
        border:'1px solid green',
        minWidth:'150px', 
      }
    },
    option:(styles,{data,isDisabled,isFocused,isSelected})=>{
      return {
        ...styles,
        backgroundColor:isSelected?'green':'transparent',
        color:isSelected?'white':'black', 
         
        ':hover':{
          backgroundColor:'lightgreen'
        },
        ':active':{
          ...styles[':active'],
          backgroundColor:'red',
          color:'white'
  
        }
      }
    }
  })

const Select = (props:any) => {
  return (
    <ReactSelect 
        name="ExamName"
        styles={SelectStyles}
        onChange={props.onChange}
        placeholder={props.placeholder ||"Select ExamPeriod"}
        options={props.options||[]} />
    )
  }

export default Select